import type { NuancesMarque } from './marque';

/**
 * Les nuances de `:root` (`index.css`), celles du tout premier rendu, avant
 * que l'API ait répondu. Elles ne font foi que cet instant : la marque vient
 * ensuite de `GET /api/marque`.
 */
export const NUANCES_AVANT_CHARGEMENT: NuancesMarque = {
  navy: '#0B2A5E',
  deep: '#0A2147',
  blue: '#104890',
  sky: '#2E7DD7',
  mint: '#C0D117',
  teal: '#9DAE10',
  accentTexte: '#5C6A0E',
  accentPale: '#EEF4C9',
  skyTexte: '#246ABC',
  tealTexte: '#687409',
};
